/**
 * Section of articles by given month.
 */

import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'
import { Link } from 'gatsby'
import { SiteConfigContext } from '@jelly/components'

export const ArticlesContainer = styled.div`
	display: block;
	padding: 0 10px;
	${({ theme }) => theme.MQ.XL} {
		padding: 0;
	}
`
export const ArticleLink = styled(Link)`
	color: ${({ theme }) => theme.colors.primary};
	display: block;
	font-size: 1.2rem;
	font-weight: 700;
	padding: 1rem 0;
	width: fit-content;
	word-break: break-all;

	&:hover {
		color: ${({ theme }) => theme.colors.tertiary};
	}
`
export const Date = styled.p`
	color: ${({ theme }) => theme.colors.gray[800]};
	${({ theme }) => theme.fonts.primary};
	font-size: 1rem;
	opacity: 0.5;
`
export const ArticleList = styled.ul`
	padding: 0;
`

export const ArticlesByMonth = ({ data }) => {
	const dates = Object.keys(data)
	const {
		siteConstants: { SITE_HOST },
	} = useContext(SiteConfigContext)
	return (
		<ArticlesContainer>
			{dates.map((date) => (
				<div key={date}>
					<Date>{date}</Date>
					{data[date].map((article) => (
						<ArticleList key={article.path}>
							<ArticleLink to={`${SITE_HOST}${article.path}`}>{article.title}</ArticleLink>
						</ArticleList>
					))}
				</div>
			))}
		</ArticlesContainer>
	)
}

ArticlesByMonth.propTypes = {
	data: object,
}
